module.exports = __webpack_public_path__ + "static/media/pic-sl4.9bee5dff.png";